"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMailboxRegionalConfiguration_1 = require("../services/getMailboxRegionalConfiguration");
var setRegionalConfiguration_1 = require("../data/mutators/setRegionalConfiguration");
var loadTimeZoneOptions_1 = require("./loadTimeZoneOptions");
function loadRegionalOptions() {
    return Promise.all([
        getMailboxRegionalConfiguration_1.default().then(function (options) {
            setRegionalConfiguration_1.default(options.SupportedCultures, options.SupportedShortDateFormats, options.SupportedShortTimeFormats);
        }),
        loadTimeZoneOptions_1.default(),
    ]);
}
exports.default = loadRegionalOptions;
//# sourceMappingURL=loadRegionalOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/orchestration/loadRegionalOptions.js
// module id = 4919
// module chunks = 2